import { convertToSeconds } from 'components/UrPlayer/hooks/startTime'
import { Plugin } from '../../types'

const pauseOnTime = (endTime: string | undefined): Plugin => {
  return (jwPlayer: jwplayer.JWPlayer, _) => {
    if (!endTime) {
      return
    }

    const endInSeconds = convertToSeconds(endTime)

    jwPlayer.on('time', (time: jwplayer.TimeParam) => {
      if (time.position > endInSeconds) {
        jwPlayer.pause(true)
      }
    })
  }
}

export default pauseOnTime
